/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Analyze_Allocations_OccupancyInputs */

const en_admin_analyze_allocations_occupancy = /** @type {(inputs: Admin_Analyze_Allocations_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Occupancy`)
};

const de_admin_analyze_allocations_occupancy = /** @type {(inputs: Admin_Analyze_Allocations_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auslastung`)
};

const es_admin_analyze_allocations_occupancy = /** @type {(inputs: Admin_Analyze_Allocations_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocupación`)
};

const fr_admin_analyze_allocations_occupancy = /** @type {(inputs: Admin_Analyze_Allocations_OccupancyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux d'occupation`)
};

/** @type {(inputs: Admin_Analyze_Allocations_OccupancyInputs) => LocalizedString} */
const it_admin_analyze_allocations_occupancy = en_admin_analyze_allocations_occupancy;

/** @type {(inputs: Admin_Analyze_Allocations_OccupancyInputs) => LocalizedString} */
const pt_br2_admin_analyze_allocations_occupancy = en_admin_analyze_allocations_occupancy;

/** @type {(inputs: Admin_Analyze_Allocations_OccupancyInputs) => LocalizedString} */
const pl_admin_analyze_allocations_occupancy = en_admin_analyze_allocations_occupancy;

/** @type {(inputs: Admin_Analyze_Allocations_OccupancyInputs) => LocalizedString} */
const hu_admin_analyze_allocations_occupancy = en_admin_analyze_allocations_occupancy;

/** @type {(inputs: Admin_Analyze_Allocations_OccupancyInputs) => LocalizedString} */
const ro_admin_analyze_allocations_occupancy = en_admin_analyze_allocations_occupancy;

/**
* | output |
* | --- |
* | "Occupancy" |
*
* @param {Admin_Analyze_Allocations_OccupancyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_analyze_allocations_occupancy = /** @type {((inputs?: Admin_Analyze_Allocations_OccupancyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Analyze_Allocations_OccupancyInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_analyze_allocations_occupancy(inputs)
	if (locale === "de") return de_admin_analyze_allocations_occupancy(inputs)
	if (locale === "es") return es_admin_analyze_allocations_occupancy(inputs)
	if (locale === "fr") return fr_admin_analyze_allocations_occupancy(inputs)
	if (locale === "it") return it_admin_analyze_allocations_occupancy(inputs)
	if (locale === "pt-BR") return pt_br2_admin_analyze_allocations_occupancy(inputs)
	if (locale === "pl") return pl_admin_analyze_allocations_occupancy(inputs)
	if (locale === "hu") return hu_admin_analyze_allocations_occupancy(inputs)
	return ro_admin_analyze_allocations_occupancy(inputs)
});
export { admin_analyze_allocations_occupancy as "admin.analyze.allocations.occupancy" }